export class DateFormatterValueConverter {
    toView(value, type = 'calendar', format) {
        if (!value) {
            return;
        }

        const date = new Date(value);

        switch (type) {
            case 'calendar': {
                // There isn't a direct equivalent of moment's 'calendar' in Intl,
                // so you might need to implement custom logic depending on your needs.
                // This is a simple example that just shows today, yesterday, or the full date.
                const today = new Date();
                const yesterday = new Date(today);
                yesterday.setDate(yesterday.getDate() - 1);

                if (date.toDateString() === today.toDateString()) {
                    return 'Today';
                } else if (date.toDateString() === yesterday.toDateString()) {
                    return 'Yesterday';
                }
                return new Intl.DateTimeFormat('default', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                }).format(date);

            }
            case 'format': {
                // The format string needs to be adapted to the options supported by Intl.DateTimeFormat
                // Here's an example that corresponds to 'MMMM Do YYYY, h:mm A' in moment
                const options = {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                };
                return new Intl.DateTimeFormat('default', options).format(date);
            }
            default: {
                // For UTC to local conversion and formatting
                const options = format || {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                };
                return new Intl.DateTimeFormat('default', options).format(new Date(date.toLocaleString()));
            }
        }
    }
}
